<script lang="ts">
	import { getTranslate } from "../utils/getTranslate";
	import translations from "../templates/Homepage.translations.json";
	import Link from "./Link.svelte";
	import { nbspify } from "../../../core/utils/nbspify";
	import { formatPrice } from "../../../core/schema/utils/formatPrice";
	import { getTenant } from "../contexts/tenantContextKey";
	import imgFire from "../../../core/assets/images/fire.png?webp&w=30&imagetools";
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import check from "../../../core/assets/icons/check.svg?raw";
	import times from "../../../core/assets/icons/times.svg?raw";
	import Icon from "./Icon.svelte";
	import { getGlobalSettings } from "../getGlobalSettings";
	import { localeToCurrencyMap } from "../../../core/schema/names/localeToCurrencyMap";
	import { Currency } from "../../../core/schema/Currency";
	import { getSignUpUrl } from "../utils/getSignUpUrl";

	const { locale } = getTenant();
	const { WEB_URL } = getGlobalSettings();
	const translate = getTranslate(translations);

	const currency = localeToCurrencyMap[locale];
	const pricePerMonth = {
		[Currency.CZK]: 0,
		[Currency.EUR]: 0,
	}[currency];
	const premiumPricePerMonth = {
		[Currency.CZK]: 199,
		[Currency.EUR]: 7.99,
	}[currency];
	const premiumPricePerYearDiscounted = {
		[Currency.CZK]: 1188,
		[Currency.EUR]: 49.99,
	}[currency];

	/* eslint-disable svelte/no-at-html-tags */
</script>

<div class="flex max-w-[27.8rem] flex-col rounded-md bg-white p-8 drop-shadow-md">
	<div class="flex flex-col">
		<span class="text-xs leading-tight">FREE</span>
		<span class="text-4xs">{translate("withoutSubscription")}</span>
	</div>
	<span class="text-2xl font-bold">{nbspify(formatPrice(pricePerMonth, locale, false, currency))}</span>
	<span class="text-4xs xl:text-3xs">{translate("perMonth")}</span>

	<div class="my-6 flex flex-col">
		<p class="text-3xs border-secondary-100 mb-0 flex items-center gap-2 border-b py-2">
			<Icon icon={check} class="text-green h-3" />
			<span>{@html translate("free1")}</span>
		</p>
		<p class="text-3xs border-secondary-100 mb-0 flex items-center gap-2 border-b py-2">
			<Icon icon={check} class="text-green h-3" /><span>{@html translate("free2")}</span>
		</p>
		<p class="text-3xs border-secondary-100 mb-0 flex items-center gap-2 border-b py-2">
			<Icon icon={check} class="text-green h-3" /><span>{@html translate("free3")}</span>
		</p>
		<p class="text-3xs border-secondary-100 mb-0 flex items-center gap-2 border-b py-2">
			<Icon icon={check} class="text-green h-3" /><span>{@html translate("free4")}</span>
		</p>
		<p class="text-3xs border-secondary-100 mb-0 flex items-center gap-2 border-b py-2">
			<Icon icon={times} class="text-primary h-3" /><span>{@html translate("free5")}</span>
		</p>
		<p class="text-3xs border-secondary-100 mb-0 flex items-center gap-2 border-b py-2">
			<Icon icon={times} class="text-primary h-3" /><span>{@html translate("free6")}</span>
		</p>
	</div>

	<Link variant="dark" asButton href={`${WEB_URL}/users/sign-up`} class="mx-auto mt-4 text-center">
		{@html translate("signInAsFreeMember")}
	</Link>
</div>
<div
	class="bg-secondary relative flex max-w-full flex-col rounded-md p-8 text-white drop-shadow-md max-xl:order-first xl:min-w-[29rem]"
>
	<span class="flex items-end justify-between">
		<div class="flex items-end gap-3 text-xs">
			<StaticPicture width={30} height={30} image={imgFire} alt="fire" class="inline-block" />
			<div class="flex flex-col">
				<span class="text-xs leading-tight">PREMIUM</span>
				<span class="text-4xs text-secondary-100">{translate("premiumSubscriptionYear")}</span>
			</div>
		</div>
		<span
			class="text-4xs lg:text-3xs bg-primary absolute right-0 ml-3 rounded-l-full px-3 py-1 font-medium leading-5 text-white"
		>
			{translate("pricingSavings")}
			<span class="font-semibold">
				{nbspify(formatPrice(premiumPricePerMonth * 12 - premiumPricePerYearDiscounted, locale, false, currency))}
			</span>
		</span>
	</span>
	<span class="text-gold text-2xl font-bold lg:text-[4rem]">
		{nbspify(formatPrice(premiumPricePerYearDiscounted / 12, locale, false, currency))}
	</span>
	<span class="text-4xs xl:text-3xs flex items-center gap-2">
		{translate("perMonth")} |
		<span class="text-primary line-through">
			{nbspify(formatPrice(premiumPricePerMonth * 12, locale, false, currency))}
		</span>
		{nbspify(formatPrice(premiumPricePerYearDiscounted, locale, false, currency))}
		{translate("perYear")}
	</span>

	<div class="my-6 flex flex-col">
		<p class="text-3xs xl:text-2xs border-secondary-300 mb-0 flex items-center gap-3 border-b py-2">
			<Icon icon={check} class="text-green h-4" />
			<span>{@html translate("premium1")}</span>
		</p>
		<p class="text-3xs xl:text-2xs border-secondary-300 mb-0 flex items-center gap-3 border-b py-2">
			<Icon icon={check} class="text-green h-4" /><span>{@html translate("premium2")}</span>
		</p>
		<p class="text-3xs xl:text-2xs border-secondary-300 mb-0 flex items-center gap-3 border-b py-2">
			<Icon icon={check} class="text-green h-4" /><span>{@html translate("premium3")}</span>
		</p>
		<p class="text-3xs xl:text-2xs border-secondary-300 mb-0 flex items-center gap-3 border-b py-2">
			<Icon icon={check} class="text-green h-4" /><span>{@html translate("premium4")}</span>
		</p>
		<p class="text-3xs xl:text-2xs border-secondary-300 mb-0 flex items-center gap-3 border-b py-2">
			<Icon icon={check} class="text-green h-4" /><span>{@html translate("premium5")}</span>
		</p>
		<p class="text-3xs xl:text-2xs border-secondary-300 mb-0 flex items-center gap-3 border-b py-2">
			<Icon icon={check} class="text-green h-4" />
			<span>{@html translate("premium6")}</span>
		</p>
	</div>

	<Link variant="gold" asButton href={`${WEB_URL}/users/sign-up?premium=Year`} class="mx-auto mt-4">
		{@html translate("signInAsPremiumMember")}
	</Link>
</div>

<div class="bg-secondary flex max-w-[27.8rem] flex-col rounded-md p-8 text-white drop-shadow-md">
	<div class="flex flex-col">
		<span class="text-xs leading-tight">PREMIUM</span>
		<span class="text-4xs text-secondary-100">{translate("premiumSubscriptionMonth")}</span>
	</div>
	<span class="text-gold text-2xl font-bold">
		{nbspify(formatPrice(premiumPricePerMonth, locale, false, currency))}
	</span>
	<span class="text-4xs xl:text-3xs">{translate("perMonth")}</span>

	<div class="my-6 flex flex-col">
		<p class="text-3xs border-secondary-300 mb-0 flex items-center gap-2 border-b py-2">
			<Icon icon={check} class="text-green h-3" /><span>{@html translate("premium1")}</span>
		</p>
		<p class="text-3xs border-secondary-300 mb-0 flex items-center gap-2 border-b py-2">
			<Icon icon={check} class="text-green h-3" /><span>{@html translate("premium2")}</span>
		</p>
		<p class="text-3xs border-secondary-300 mb-0 flex items-center gap-2 border-b py-2">
			<Icon icon={check} class="text-green h-3" /><span>{@html translate("premium3")}</span>
		</p>
		<p class="text-3xs border-secondary-300 mb-0 flex items-center gap-2 border-b py-2">
			<Icon icon={check} class="text-green h-3" /><span>{@html translate("premium4")}</span>
		</p>
		<p class="text-3xs border-secondary-300 mb-0 flex items-center gap-2 border-b py-2">
			<Icon icon={check} class="text-green h-3" /><span>{@html translate("premium5")}</span>
		</p>
		<p class="text-3xs border-secondary-300 mb-0 flex items-center gap-2 border-b py-2">
			<Icon icon={check} class="text-green h-3" /><span>{@html translate("premium6")}</span>
		</p>
	</div>

	<Link variant="gold" asButton href={`${getSignUpUrl(WEB_URL)}?premium=Month`} class="mx-auto mt-4">
		{@html translate("signInAsPremiumMember")}
	</Link>
</div>
